import React, { useLayoutEffect, useState } from "react";

const MarketoForm = ({
  formId,
  thankyouHeading,
  thankyouButtonText,
  resourceURL,
}) => {
  const [formSuccess, setFormSuccess] = useState(false);
  const thankyouHeadingUpdated = thankyouHeading
    ? thankyouHeading
    : "Thank you";
  const thankyouButtonTextUpdated = thankyouButtonText
    ? thankyouButtonText
    : "Download now";

  useLayoutEffect(() => {
    if (formId) {
      window.MktoForms2.loadForm(
        "//info.lacework.com",
        "016-ATL-295",
        formId,
        marketoCallback
      );

      function marketoCallback(form) {
        form.onSuccess(function (values, followUpUrl) {
          setFormSuccess(true);
          return false;
        });
      }
    }
  }, []);

  return formSuccess ? (
    <div className="thank-you-container">
      <h4 className="thank-you-heading">{thankyouHeadingUpdated}</h4>
      <a className="thank-you-button" href={resourceURL}>
        {thankyouButtonTextUpdated}
      </a>
    </div>
  ) : (
    <form id={`mktoForm_${formId}`} data-module="MarketoScripts"></form>
  );
};

export default MarketoForm;
